export default __webpack_public_path__ + "static/media/white_receipt.ec2fae66.svg";